import { Link } from "react-router-dom";
import { articles } from "@/mocks/content";
import ArticleCard from "@/components/feature/ArticleCard";

export default function FeaturedPicks() {
  const picks = articles.filter((a) => !a.hot).slice(0, 4);

  return (
    <section id="picks" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <span className="text-xs md:text-sm text-secondary-700 font-medium">编辑挑选</span>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-1">
              值得慢慢读的现场记录
            </h2>
            <p className="text-sm text-foreground-600 mt-4 leading-relaxed">
              热料榜之外，我们也挑出了一些节奏更慢、信息更扎实的内容。它们可能不在最热的位置，但读完之后往往更耐回味。
            </p>
            <Link
              to="/category/lifestyle"
              className="inline-flex items-center gap-1.5 mt-6 text-sm text-primary-700 hover:text-primary-800 cursor-pointer"
            >
              查看更多生活记录
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>
          </div>
        </aside>

        <div className="lg:col-span-8 flex flex-col gap-4">
          {picks.map((a) => (
            <ArticleCard key={a.id} article={a} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}